export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        rowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectSearchConfig'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteSearchConfigRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteSearchConfigRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "userId",
                label: "Felhasználó",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                visibility: true,
                formVisible: true,
                formSize: 3,
                formType: "text",
                formRequired: true
            },
            {
                name: "description",
                label: "Leírás",
                visibility: true,
                formVisible: true,
                formSize: 6,
                formType: "text"
            },
            {
                name: "configJson",
                label: "Config JSON",
                visibility: false
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: false
            },
            {
                name: "createdOn",
                label: "Dokumentum létrehozása",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
